export abstract class Identifiable<ID> {
  id?: ID;
}
